/* src/components/library-item-quantification-grid/library-item-quantification-grid.component.scss */
:host {
  display: block;
}
.quantification__row {
  display: flex;
  width: 100%;
  padding-top: 1rem;
}
.quantification__column {
  flex: 1 1;
  margin-right: 0.2rem;
  border-radius: 0.5rem;
  border: 1px solid var(--vwui--color--neutral-3);
}
.quantification__column--index-0 {
  padding-top: 3.2rem;
  border-color: transparent;
  width: 3rem;
  min-width: 3rem;
  max-width: 3rem;
}
.quantification__column--index-1 {
  background: var(--vwui-color-neutral-4);
}
.quantification__column--disabled {
  pointer-events: none;
  color: var(--vwui-color-neutral-2);
  background: var(--vwui-color-neutral-4);
}
.quantification__column:last-of-type {
  margin-right: 0;
}
.quantification__column-top {
  position: relative;
  height: 3.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: var(--vwui--font--semibold);
  border-bottom: 1px solid var(--vwui--color--neutral-3);
  box-sizing: border-box;
}
.quantification__column-icon {
  --size: 1rem;
  color: var(--vwui-color-primary);
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background: #fff;
  border-radius: 50%;
  padding: 0.7rem;
  box-sizing: content-box;
}
.quantification__column-icon--disabled {
  color: var(--vwui-color-neutral-2);
  background: var(--vwui-color-neutral-4);
}
.quantification__column-icon::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  border: 1px solid;
  border-color: var(--vwui--color--neutral-3) var(--vwui--color--neutral-3) transparent transparent;
  transform: rotate(-45deg);
}
.quantification__column__values {
  display: flex;
  flex-direction: column;
  background: var(--vwui-color-neutral-4);
  padding: 0.25rem;
}
.quantification__column__value {
  height: 3rem;
  border-radius: 0.5rem;
  border: 1px solid var(--vwui--color--neutral-3);
  background: var(--vwui--color--light);
  margin-bottom: 0.25rem;
  padding: 0 var(--vwui-size-spacing-xs);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  position: relative;
  transition: color 300ms ease-out, background 300ms ease-out;
  text-align: center;
}
.quantification__column__value--active {
  color: var(--vwui-color-primary);
  background: var(--vwui-color-secondary);
}
.quantification__column__value--disabled {
  background: var(--vwui-color-neutral-2);
}
.quantification__column__value:last-of-type {
  margin-bottom: 0;
}
.quantification__column-rows {
  display: flex;
  flex-direction: column;
  padding-top: 0.25rem;
}
.quantification__column-row {
  height: 3rem;
  border-radius: 0.5rem;
  border: 1px solid var(--vwui--color--neutral-4);
  background: var(--vwui--color--neutral-4);
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.quantification__column-row:last-of-type {
  margin-bottom: 0;
}
/*# sourceMappingURL=library-item-quantification-grid.component-CJMI6YFX.css.map */
